var map = {
	"./admin.vue": [
		70304,
		4736,
		3064
	],
	"./arkatar.vue": [
		70260,
		4736,
		3064
	],
	"./home.vue": [
		28777,
		4736,
		3064
	],
	"./menaxher.vue": [
		11173,
		4736,
		3064
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 94241;
module.exports = webpackAsyncContext;